import { Dropdown, Menu } from "antd";

import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateAppointments } from "../store/slices/appointmentsSlice";
import Request from "./request";
import dayjs from "dayjs";
import { getDateTimeDate } from "../utils/timeHelpers";
import { useAppointments } from "../hooks/useAppointments";

function RequestMenu({ children, hideDot }) {
  const qalortUser = useSelector((state) => state.user.userData);
  const dispatch = useDispatch();
  const { data: myAppointments, refetch } = useAppointments();

  const pendingAppointments = useMemo(() => {
    return myAppointments?.filter(
      (a) =>
        a.status === "pending" &&
        a.host_id !== qalortUser?._id &&
        (dayjs(getDateTimeDate(a.start_date)).isAfter(
          dayjs().format("YYYY-MM-DD")
        ) ||
          dayjs(getDateTimeDate(a.start_date)).isSame(
            dayjs().format("YYYY-MM-DD")
          ))
    );
  }, [myAppointments]);

  const showDot = pendingAppointments?.length;

  const menu = (
    <Menu
      style={{ maxHeight: 250, width: 330, overflow: "auto" }}
      items={
        pendingAppointments
          ? pendingAppointments?.map((itm, i) => {
              return {
                key: i,
                label: (
                  <Request
                    fetchData={() => {
                      refetch();
                    }}
                    request={itm}
                    key={i}
                  />
                ),
              };
            })
          : []
      }
    />
  );

  return (
    <Dropdown
      overlay={
        pendingAppointments?.length ? (
          menu
        ) : (
          <Menu>
            <div className="p-2">You have no pending appointments</div>
          </Menu>
        )
      }
      placement="bottomLeft"
    >
      <div data-testid="request_menu" className="relative">
        {children}
        {!!showDot && !hideDot && (
          <div
            data-testid="request_dot"
            className="absolute left-3 -top-2 bg-red rounded-full w-4 h-4 text-white flex items-center justify-center text-[8px]"
          >
            {pendingAppointments.length}
          </div>
        )}
      </div>
    </Dropdown>
  );
}

export default RequestMenu;
